export default __webpack_public_path__ + "static/samsungknox-44115ce4e00446c07790f2b870e22c43.png";